export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/rep/subject/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/rep/subject/get?id=${data.id}`,
                data
            })
        },

        saveInfo(data) {
            return http.json({
                url: `/rep/subject/save`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/rep/subject/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/rep/subject/delete`,
                data
            })
        },

        updateState(data) {
            return http.json({
                url: `/rep/subject/updateState`,
                data
            })
        },
    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/subject.js